/* Biolgical universal funnel-events tracker (2026-07-29).
 * Fires the full PostHog funnel event set + FAILURE events on ANY page (custom {% layout none %}
 * landers included) by intercepting the store's cart AJAX / form. Failures also go to
 * posthog.captureException() so they appear on PostHog → Error tracking as issues.
 * Requires posthog already init'd + posthog.register({offer:...}) (present in our templates).
 * Defensive: every hook is try/caught and NEVER blocks the original request. Safe to drop in <head>.
 */
(function () {
  try {
    if (!window.posthog) return;
    // offer tag: resolved LAZILY at capture time, not at load. This script is `defer`-loaded and
    // posthog.js is async, so reading persistence once at init raced it and stamped offer=null on
    // every event (everly PDP, 2026-07-30 — 7 add_to_cart with offer:None).
    function OFFER() {
      try { var g = posthog.get_property && posthog.get_property('offer'); if (g) return g; } catch (e) {}
      try { var p = posthog.persistence && posthog.persistence.props && posthog.persistence.props.offer; if (p) return p; } catch (e) {}
      return document.documentElement.getAttribute('data-offer') || null;
    }

    function cap(ev, props) { try { posthog.capture(ev, Object.assign({ offer: OFFER(), page: location.pathname }, props || {})); } catch (e) {} }
    function fail(name, props) {
      try { posthog.capture(name, Object.assign({ offer: OFFER(), page: location.pathname }, props || {})); } catch (e) {}
      try { posthog.captureException(new Error(name + (props && props.status ? ' status=' + props.status : '')), Object.assign({ offer: OFFER(), page: location.pathname, funnel_failure: true }, props || {})); } catch (e) {}
    }

    // one add = one event: the fetch hook and the form hook can both see the same add, and a
    // double-click fires twice. Collapse anything inside 1.5s.
    var _lastAtc = 0;
    function capAtc(props) {
      // Opt-out for pages that ALREADY fire their own add_to_cart. The 1.5s guard below only
      // dedupes OUR calls — a page script calling posthog.capture('add_to_cart') directly slips
      // past it, so we double-counted every add on phoilex (2 events 44-53ms apart, 2026-07-30)
      // once this tracker landed on a design whose pfx_interactivity.v4.js already captures ATC.
      // Those pages set window.__phSkipAtc; they keep the FAILURE events, which is why the
      // tracker is there at all.
      if (window.__phSkipAtc) return;
      var t = new Date().getTime();
      if (t - _lastAtc < 1500) return;
      _lastAtc = t;
      cap('add_to_cart', props);
    }
    if (window.__phFunnelEvents) return; window.__phFunnelEvents = true;

    // 0) product_viewed — the PostHog twin of Meta's ViewContent, and the step our funnels were
    // missing entirely. Audited 2026-08-02: 0 events on phoilex against 1,715 PDP pageviews,
    // 3 on biolgical against 579. It was in EVENT-TAXONOMY.md but in no gate, so nothing ever
    // fired it and every pageview->product_viewed->add_to_cart funnel read a phantom 100% drop
    // at step two. Meta HAS had ViewContent this whole time (pfx_track is_pdp:true) — only our
    // side was blind, which is the worst shape: it looks measured until you check.
    // Opt-out: window.__phSkipProductViewed (for a page that already fires its own).
    function isPdp() {
      try {
        if (window.__phIsPdp === true) return true;
        if (window.__phIsPdp === false) return false;
        if (/\/products\//.test(location.pathname)) return true;
        return !!document.querySelector('form[action*="/cart/add"]');
      } catch (e) { return false; }
    }
    function productProps() {
      var p = {};
      try {
        var m = location.pathname.match(/\/products\/([^/?#]+)/);
        if (m) p.product_handle = m[1];
        // variant_id is the canonical id in SYSTEM-LANGUAGE.md — read it from the add-to-cart
        // form rather than guessing, and send it as a string like every other surface does.
        var v = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (v && v.value) p.variant_id = String(v.value);
        var h1 = document.querySelector('h1');
        if (h1 && h1.textContent) p.product_title = h1.textContent.trim().slice(0, 120);
      } catch (e) {}
      return p;
    }
    function fireProductViewed() {
      try {
        if (window.__phSkipProductViewed || window.__phProductViewed) return;
        if (!isPdp()) return;
        window.__phProductViewed = true;
        cap('product_viewed', productProps());
      } catch (e) {}
    }
    // the add-to-cart form can be rendered late by a theme/app, so try at ready AND after load;
    // the __phProductViewed latch keeps it to exactly one event either way.
    if (document.readyState !== 'loading') fireProductViewed();
    else document.addEventListener('DOMContentLoaded', fireProductViewed);
    window.addEventListener('load', fireProductViewed);

    // 1) intercept fetch — catches AJAX /cart/add(.js) and /cart/change, plus checkout starts
    if (window.fetch) {
      var _f = window.fetch;
      window.fetch = function (input, opts) {
        var url = ''; try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
        var pr = _f.apply(this, arguments);
        try {
          if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
            pr.then(function (res) {
              try {
                if (res && res.ok) { capAtc({ source: 'ajax' }); }
                else if (res) {
                  res.clone().text().then(function (t) {
                    var body = (t || '').slice(0, 240);
                    fail('add_to_cart_error', { status: res.status, body: body });
                    if (/selling plan/i.test(body)) fail('selling_plan_attach_failed', { status: res.status, body: body });
                    if (/sold out|unavailable|not enough/i.test(body)) fail('add_to_cart_out_of_stock', { status: res.status, body: body });
                  }).catch(function () { fail('add_to_cart_error', { status: res.status }); });
                }
              } catch (e) {}
            }).catch(function () { fail('add_to_cart_error', { status: 'network' }); });
          }
        } catch (e) {}
        return pr;
      };
    }

    // 2) native (non-AJAX) form submit to /cart/add
    document.addEventListener('submit', function (e) {
      try {
        var f = e.target; var a = f && f.getAttribute && f.getAttribute('action');
        if (a && /\/cart\/add/.test(a)) capAtc({ source: 'form' });
      } catch (err) {}
    }, true);

    // 3) checkout_started — checkout button / cart-drawer checkout / nav to /checkout|/cart
    //    PLUS [data-direct-checkout]: an OPT-IN attribute for buy buttons that skip the cart and
    //    go straight to /checkouts/… (everly PDP). Without it those pages recorded add_to_cart but
    //    NEVER a checkout start — there is no second click to catch. Opt-in, so pages whose ATC
    //    only opens a cart drawer never fire a false one.
    //
    //    ⛔ RENAMED 2026-08-07: this fired the DEPRECATED `initiate_checkout`. EVENT-TAXONOMY.md
    //    settled on `checkout_started` and the router has emitted that name for months, so the
    //    checkout stage was split across TWO names in PostHog (phoilex 7d: checkout_started 133
    //    router + 28 web, initiate_checkout 45 web) and every checkout count was wrong unless you
    //    remembered to union them. `$lib` still distinguishes web from shopify-pixel-router, and
    //    capi_funnel_sync.py excludes $lib='web', so this rename does NOT create a CAPI double-fire.
    //    Historical `initiate_checkout` rows stay in PostHog — union both names for any window
    //    spanning this date. [[a-proxy-cannot-express-what-it-doesnt-measure]]
    document.addEventListener('click', function (e) {
      try {
        var t = e.target.closest ? e.target.closest('[name="checkout"],a[href*="/checkout"],a[href*="/cart"],button[href*="/checkout"],[data-testid*="checkout"],.js-checkout,#checkout,.cart__checkout,[data-direct-checkout]') : null;
        if (t) cap('checkout_started', { direct: !!(t.hasAttribute && t.hasAttribute('data-direct-checkout')) });
      } catch (err) {}
    }, true);

    // 4) empty-cart checkout attempt = a broken/edge funnel state worth catching
    document.addEventListener('click', function (e) {
      try {
        var t = e.target.closest ? e.target.closest('[name="checkout"],.cart__checkout,#checkout') : null;
        if (!t) return;
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          if (c && (!c.item_count || c.item_count === 0)) fail('checkout_empty_cart', {});
        }).catch(function () {});
      } catch (err) {}
    }, true);

    // 4b) OFFER + CONTENT INTERACTIONS — the layer that was completely uninstrumented.
    //
    // WHY THIS EXISTS. Until now the ONLY fact recorded about the offer was the terminal
    // `add_to_cart`. Everything between "sees the CTA" and "adds" was invisible, so offer-vs-page
    // could not be separated from data at all.
    //
    // ⛔ SELECTORS VERIFIED AGAINST THE LIVE TEMPLATE (product.aughs-petlab-v2.liquid, theme
    // 158300536879, 2026-08-07). A first pass of this block used the generic names you would
    // GUESS (data-ph-tier, .tier-option, data-selling-plan-id, details>summary) and every single
    // one matched ZERO times — it would have shipped as dead code. Only `.faq-question` hit.
    // If you port this to another template, RE-RUN that check; do not assume.
    //
    // THE REAL ARCHITECTURE (and it is NOT a plain sticky selector): the offer lives in a DRAWER.
    //   `.select-offer-btn`      opens it — TWO of them, one in the hero and one in the sticky bar
    //   `.offer-drawer-close` / `.offer-drawer-overlay`  close it
    //   `#sizes`  dog-size picker   `#tiers > .tier[data-i]`  tier cards (JS-rendered)
    //   `input[data-auto]`  the Autoship & Save subscribe toggle
    //   `.row-add[data-add]`  addon add buttons        `#atc`  the real add-to-cart
    // So the offer IS gated behind a click. That gate is the exposure event the whole
    // offer-vs-page question needed and nothing was recording it.
    // ⚠ It also means `section_view = "Choose Your Package"` may have been an ACCIDENTAL proxy for
    // drawer-open (that h3 sits inside the hidden drawer), not the scroll marker it looks like.
    // `offer_drawer_open` settles it — until it has data, trust neither reading.
    // [[a-proxy-cannot-express-what-it-doesnt-measure]]
    //
    // THE PRIMITIVE IS THE SEQUENCE, NOT THE COUNT. `select_seq` is the nth offer interaction of
    // the session, so the ORDER is reconstructable after the fact: 1→3→2→1 is deliberation, one
    // click then add is a decided buyer. That is why tier/plan events are NOT deduped and
    // faq_open is — an open/close/open toggle is one unanswered question, not three.
    var _selSeq = 0, _faqFired = {};

    document.addEventListener('click', function (e) {
      try {
        if (!e.target.closest) return;
        var t;

        // --- the exposure gate: drawer open. Record WHICH cta, so the sticky bar can be judged.
        if ((t = e.target.closest('[data-ph-offer-open],.select-offer-btn'))) {
          cap('offer_drawer_open', {
            source: t.className && t.className.indexOf('aughs-sticky-cta') > -1 ? 'sticky' :
                    (t.closest('#sticky-bar') ? 'sticky' : 'inline'),
            select_seq: ++_selSeq
          });
          return;
        }
        if ((t = e.target.closest('.offer-drawer-close,.offer-drawer-overlay'))) {
          cap('offer_drawer_close', {
            via: t.className.indexOf('overlay') > -1 ? 'overlay' : 'button',
            select_seq: ++_selSeq
          });
          return;
        }

        // --- subscribe / one-time toggle. Checked BEFORE tier: on the addon rows it sits inside a
        //     row and the plan is the more specific fact, so matching it as a tier would erase it.
        //
        // ⛔ THE MAIN TOGGLE IS AN <a>, NOT A CHECKBOX. `#modeLink` (`a.sublink`) lives in the
        // drawer's STICKY FOOTER under the ATC button and flips the whole order between subscribe
        // and one-time. An earlier version of this block looked only for `input[data-auto]` /
        // `[data-selling-plan-id]` / `input[type=checkbox]`, found nothing, and I concluded the PDP
        // had "no subscription path at all" — while `line.selling_plan = t.plan` sits in cartPayload()
        // and every TIERS row pairs `.variant` with `.plan`. Absence of a GUESSED selector is not
        // absence of the feature. [[instrument-against-the-rendered-dom-not-guessed-selectors]]
        //
        // The link's label names the mode it will switch TO ("Buy Once for $34" when currently on
        // subscribe), so the label IS the destination state — read it, don't infer from position.
        if ((t = e.target.closest('[data-ph-plan],#modeLink,a.sublink,input[data-auto]'))) {
          var lbl = (t.textContent || '').toLowerCase();
          cap('offer_plan_toggle', {
            plan: t.tagName === 'INPUT'
                    ? (t.checked === false ? 'one_time' : 'subscribe')
                    : (/buy once|one.?time|single/.test(lbl) ? 'one_time' : 'subscribe'),
            addon_index: t.getAttribute('data-auto') || undefined,
            select_seq: ++_selSeq
          });
          return;
        }

        // --- addon add (order bump)
        if ((t = e.target.closest('.row-add[data-add]'))) {
          cap('offer_addon_add', { addon_index: t.getAttribute('data-add'), select_seq: ++_selSeq });
          return;
        }

        // --- tier card. `.tier` carries data-i = the tier index the page itself uses.
        if ((t = e.target.closest('#tiers .tier,[data-ph-tier]'))) {
          cap('offer_tier_select', {
            tier_index: t.getAttribute('data-i') || t.getAttribute('data-ph-tier'),
            select_seq: ++_selSeq
          });
          return;
        }

        // --- dog-size picker: a real decision step, and a plausible friction point nobody watched.
        if ((t = e.target.closest('#sizes > *'))) {
          cap('offer_size_select', { size: _slug((t.textContent || '').slice(0, 40)), select_seq: ++_selSeq });
          return;
        }

        // --- FAQ. WHICH question they open is a direct read on the doubt the page failed to
        //     pre-empt: [[ec-cro-unanswered-questions-cause-80pct-of-abandonment]] puts 80% of
        //     abandonment on unanswered questions, and only 30% of brands realise it. Deduped.
        if ((t = e.target.closest('[data-ph-faq],.faq-question,details>summary'))) {
          var q = _slug((t.getAttribute('data-ph-faq') || t.textContent || '').slice(0, 80));
          if (q && !_faqFired[q]) {
            _faqFired[q] = 1;
            cap('faq_open', { question: q, faq_seq: Object.keys(_faqFired).length });
          }
        }
      } catch (err) {}
    }, true);

    // 5) ENGAGEMENT + EXIT — scroll_depth / section_view / page_exit.
    // Rationale + how to read them: TRACKING-ARCHITECTURE.md "Engagement & exit events".
    // These answer the two questions the funnel could never answer: how far down did they get,
    // and where were they standing when they left.
    var _t0 = new Date().getTime();
    var _maxDepth = 0, _lastSection = '', _lastIdx = -1, _reachedCta = false;
    var _depthFired = {}, _sectionFired = {}, _exited = false;

    function _slug(s) {
      return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '').slice(0, 60);
    }

    function _depthPct() {
      var h = document.documentElement, b = document.body;
      var st = h.scrollTop || b.scrollTop || window.pageYOffset || 0;
      var sh = (h.scrollHeight || b.scrollHeight) - h.clientHeight;
      if (sh <= 0) return 100;            // page shorter than the viewport = fully seen
      return Math.max(0, Math.min(100, Math.round((st / sh) * 100)));
    }

    // Section = an explicit data-ph-section, else the nearest heading above the viewport middle.
    // The heading fallback is the whole point: it works on every existing template with zero
    // markup changes, and a derived name beats no name. Explicit attributes win when present.
    // Re-query on a 5s TTL, never cache forever: querySelectorAll returns a STATIC NodeList and
    // this PDP injects markup after load (the gallery adds ~36 videos), so a once-cached list
    // silently misses every section added later.
    var _nodes = null, _nodesAt = 0;
    function _sectionNodes() {
      var now = new Date().getTime();
      if (!_nodes || now - _nodesAt > 5000) {
        _nodes = document.querySelectorAll('[data-ph-section],[data-section],h1,h2,h3');
        _nodesAt = now;
      }
      return _nodes;
    }
    function _currentSection() {
      try {
        var mid = (window.pageYOffset || 0) + (window.innerHeight / 2);
        var nodes = _sectionNodes(), best = '', bestIdx = -1;
        for (var i = 0; i < nodes.length; i++) {
          var top = nodes[i].getBoundingClientRect().top + (window.pageYOffset || 0);
          if (top > mid) break;           // querySelectorAll is document order — first past mid ends it
          best = nodes[i].getAttribute('data-ph-section') || nodes[i].getAttribute('data-section') || _slug(nodes[i].textContent);
          bestIdx = i;
        }
        return { name: best, index: bestIdx };
      } catch (e) { return { name: '', index: -1 }; }
    }

    var _CTA_SEL = '[data-ph-cta],a.cta,button[name="add"],.product-form__submit,' +
                   '[name="checkout"],a[href*="/cart"],a[href*="/checkout"]';
    function _checkCta() {
      if (_reachedCta) return;
      try {
        var els = document.querySelectorAll(_CTA_SEL);
        for (var i = 0; i < els.length; i++) {
          var r = els[i].getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) { _reachedCta = true; return; }
        }
      } catch (e) {}
    }

    // Throttled: getBoundingClientRect over every heading on every scroll event is a jank machine.
    var _tick = 0;
    function _onScroll() {
      var now = new Date().getTime();
      if (now - _tick < 250) return;
      _tick = now;
      var d = _depthPct();
      if (d > _maxDepth) _maxDepth = d;
      var ms = [25, 50, 75, 100];
      for (var i = 0; i < ms.length; i++) {
        if (_maxDepth >= ms[i] && !_depthFired[ms[i]]) {
          _depthFired[ms[i]] = 1;
          cap('scroll_depth', { depth_pct: ms[i] });
        }
      }
      var sec = _currentSection();
      if (sec.name && sec.name !== _lastSection) {
        _lastSection = sec.name; _lastIdx = sec.index;
        if (!_sectionFired[sec.name]) {
          _sectionFired[sec.name] = 1;
          cap('section_view', { section: sec.name, section_index: sec.index });
        }
      }
      _checkCta();
    }
    window.addEventListener('scroll', _onScroll, { passive: true });
    _onScroll();                          // a short page must still record depth 100

    // visibilitychange, NOT unload: unload does not fire reliably on mobile Safari or on a
    // backgrounded tab — precisely the sessions we most need. Guarded to emit at most once.
    // NAME: page_exit_depth, NOT page_exit. A parallel session shipped page_exit_depth
    // (a single numeric `depth`) to the aughs PDP an hour before this landed. One concept =
    // one word (SYSTEM-LANGUAGE.md), so we ADOPT their name and enrich it rather than run two
    // events that mean the same thing. `depth` is kept as the primary numeric so their existing
    // queries and insights keep working; the section/dwell/CTA fields are additive.
    // Pages that already fire their own exit event set window.__phSkipExit (same shape as
    // __phSkipAtc) or this double-counts, exactly as the ATC tracker once did on phoilex.
    function _exit(reason) {
      if (_exited || window.__phSkipExit) return;
      _exited = true;
      // The 250ms throttle drops the LAST scroll burst, so _maxDepth is stale whenever someone
      // scrolls then immediately leaves — the exact exit we care most about. Re-measure here.
      var _final = _depthPct();
      if (_final > _maxDepth) _maxDepth = _final;
      var _sec = _currentSection();
      if (_sec.name) { _lastSection = _sec.name; _lastIdx = _sec.index; }
      _checkCta();
      cap('page_exit_depth', {
        depth: _maxDepth,
        max_depth_pct: _maxDepth,
        last_section: _lastSection,
        last_section_index: _lastIdx,
        dwell_ms: new Date().getTime() - _t0,
        reached_cta: _reachedCta,
        reason: reason
      });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') _exit('hidden');
    });
    window.addEventListener('pagehide', function () { _exit('pagehide'); });

  } catch (e) { /* never break the page */ }
})();
